import { useLocalization } from '../../../lib/hooks/useLocalization';
import { AppImage } from '../../AppImage';

export function PrevIcon({ type }) {
  const { prevAlt } = useLocalization().translations.unique.components.datePicker;
  return <AppImage src='/icons/chevron-left.svg' alt={prevAlt({ type })} />;
}
